<template>
    <card class="m-2" style="height: 525px">
        <template #header-content> Users By Access Level </template>
        <template #body>
            <div v-if="showTable">
                <b-button @click="goBack" variant="primary" class="mx-1"> View Details </b-button>
                <vue-apex-charts type="bar" :options="options" :series="series" width="100%" height="400" />
            </div>

            <grid
                v-else
                ref="grid"
                :columnDefs="columnDefs"
                :fetchCallback="fetchCallback"
                gridTheme="ag-theme-alpine-report"
                :isAutoWidth="true"
                :getRowStyle="rowStyle"
                :isSearch="false"
                :buttonToolbarClass="['align-items-start flex-md-nowrap']"
                :defaultSort="sort"
                :defaultDesc="true"
                class="h-100"
            >
                <b-button @click="goBack" variant="primary" class="mr-1"> View Chart </b-button>
                <responsive-dropdown variant="primary" :items="accessLevelsDropdown" :icon="['fas', 'filter']">{{
                    accessLevelsDropdownLabel
                }}</responsive-dropdown>
                <export-to-excel-button :href="excelHref" />
                <responsive-button :icon="['fas', 'arrows-rotate']" variant="primary" @click="refresh"
                    >Refresh</responsive-button
                >
                <div class="merge-source-wrapper mb-0 subscribers-wrapper d-none d-lg-flex mr-1">
                    <form-input
                        id="source"
                        @input="(value) => searchSubscribers(value)"
                        :value="subscriberSearch"
                        placeholder="Search by subscriber"
                        autocomplete="off"
                        class="w-100"
                    />
                    <div class="merge-guests-wrapper subscribers-list-wrapper" v-if="!!subscriberSearch && busy">
                        <div class="guest-item p-2 d-flex align-items-center justify-content-center">
                            <b-spinner variant="primary" :small="true" />
                        </div>
                    </div>
                    <div
                        class="merge-guests-wrapper subscribers-list-wrapper"
                        v-else-if="subscribersList.length && subscriberSearch"
                    >
                        <div
                            class="guest-item p-2"
                            :key="subscriber.id"
                            v-for="subscriber in subscribersList"
                            @click="selectSubscriber(subscriber.text, subscriber.value)"
                        >
                            <span>{{ subscriber.text }}</span>
                        </div>
                    </div>
                    <div
                        class="merge-guests-wrapper subscribers-list-wrapper"
                        v-else-if="!subscribersList.length && !!subscriberSearch && !selectedSubscriber"
                    >
                        <div class="p-2">
                            <span class="text-center">Nothing found</span>
                        </div>
                    </div>
                    <div v-else />
                </div>

                <div class="merge-source-wrapper mb-0 subscribers-wrapper d-none d-lg-flex mr-1">
                    <form-input
                        id="source"
                        autocomplete="off"
                        placeholder="Search by user"
                        @input="(value) => searchUsers(value)"
                        :value="userSearch"
                        class="w-100"
                    />
                    <div class="merge-guests-wrapper subscribers-list-wrapper" v-if="!!userSearch && busy">
                        <div class="guest-item p-2 d-flex align-items-center justify-content-center">
                            <b-spinner variant="primary" :small="true" />
                        </div>
                    </div>
                    <div
                        class="merge-guests-wrapper subscribers-list-wrapper"
                        v-else-if="usersList.length && userSearch"
                    >
                        <div
                            class="guest-item p-2"
                            :key="user.id"
                            v-for="user in usersList"
                            @click="selectUser(user.text, user.value)"
                        >
                            <span>{{ user.text }}</span>
                        </div>
                    </div>
                    <div
                        class="merge-guests-wrapper subscribers-list-wrapper"
                        v-else-if="!usersList.length && !!userSearch && !selectedUser"
                    >
                        <div class="p-2">
                            <span class="text-center">Nothing found</span>
                        </div>
                    </div>
                    <div v-else />
                </div>

                <b-button-group class="d-lg-none d-block">
                    <more-filters-dropdown>
                        <div class="merge-source-wrapper mb-0 subscribers-wrapper d-flex d-lg-none mr-1">
                            <form-input
                                id="source"
                                @input="(value) => searchSubscribers(value)"
                                :value="subscriberSearch"
                                placeholder="Search by subscriber"
                                autocomplete="off"
                                class="w-100"
                            />
                            <div
                                class="merge-guests-wrapper subscribers-list-wrapper"
                                v-if="!!subscriberSearch && busy"
                            >
                                <div class="guest-item p-2 d-flex align-items-center justify-content-center">
                                    <b-spinner variant="primary" :small="true" />
                                </div>
                            </div>
                            <div
                                class="merge-guests-wrapper subscribers-list-wrapper"
                                v-else-if="subscribersList.length && subscriberSearch"
                            >
                                <div
                                    class="guest-item p-2"
                                    :key="subscriber.id"
                                    v-for="subscriber in subscribersList"
                                    @click="selectSubscriber(subscriber.text, subscriber.value)"
                                >
                                    <span>{{ subscriber.text }}</span>
                                </div>
                            </div>
                            <div
                                class="merge-guests-wrapper subscribers-list-wrapper"
                                v-else-if="!subscribersList.length && !!subscriberSearch && !selectedSubscriber"
                            >
                                <div class="p-2">
                                    <span class="text-center">Nothing found</span>
                                </div>
                            </div>
                            <div v-else />
                        </div>
                        <div class="merge-source-wrapper mb-0 subscribers-wrapper d-flex d-lg-none mr-1">
                            <form-input
                                id="source"
                                @input="(value) => searchUsers(value)"
                                :value="userSearch"
                                placeholder="Search by user"
                                autocomplete="off"
                                class="w-100"
                            />
                            <div
                                class="merge-guests-wrapper subscribers-list-wrapper"
                                v-if="!!subscriberSearch && busy"
                            >
                                <div class="guest-item p-2 d-flex align-items-center justify-content-center">
                                    <b-spinner variant="primary" :small="true" />
                                </div>
                            </div>

                            <div
                                class="merge-guests-wrapper subscribers-list-wrapper"
                                v-else-if="usersList.length && userSearch"
                            >
                                <div
                                    class="guest-item p-2"
                                    :key="user.id"
                                    v-for="user in usersList"
                                    @click="selectUser(user.text, user.value)"
                                >
                                    <span>{{ user.text }}</span>
                                </div>
                            </div>
                            <div
                                class="merge-guests-wrapper subscribers-list-wrapper"
                                v-else-if="!usersList.length && !!userSearch && !selectedUser"
                            >
                                <div class="p-2">
                                    <span class="text-center">Nothing found</span>
                                </div>
                            </div>
                            <div v-else />
                        </div>
                    </more-filters-dropdown>
                </b-button-group>
            </grid>
        </template>
    </card>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';
import API from '../../../api';
import { ADMIN_APP_STATISTICS_ENDPOINT } from '../../../endpoints';
import DateRangePicker from '../../generic/date-range-picker/date-range-picker.vue';
import Grid from '../../generic/grid/grid.vue';
import page from '../../generic/page/page.vue';
import { truncate } from '../../../utils/strings';
import FormInput from '../../generic/form-input/form-input.vue';
import SearchMultiselect from '../../generic/search-multiselect/search-multiselect.vue';
import ExportToExcelButton from '../../generic/export-to-excel-button/export-to-excel-button.vue';
import MoreFiltersDropdown from '../../generic/more-filters-dropdown/more-filters-dropdown.vue';

import CardGrid from '../../generic/card-grid/card-grid.vue';
import VueApexCharts from 'vue3-apexcharts';
import Card from '../../generic/card/card.vue';
import ResponsiveDropdown from '../../generic/responsive-dropdown/responsive-dropdown.vue';
import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';

export default {
    components: {
        page,
        Grid,
        DateRangePicker,
        FormInput,
        SearchMultiselect,
        ExportToExcelButton,
        MoreFiltersDropdown,
        VueApexCharts,
        Card,
        CardGrid,
        ResponsiveDropdown,
        ResponsiveButton,
    },
    name: 'AdminAppAccessLevel',
    data() {
        return {
            busy: false,
            showTable: null,
            dateRequestFormat: 'yyyy-MM-dd',
            rowStyle: null,
            subscribersList: [],
            usersList: [],
            selectedSubscriber: '',
            selectedUser: '',
            subscriberSearch: '',
            userSearch: '',
            offset: 0,
            limit: 20,
            sort: 'modified',
            desc: false,
            accessLevels: [],
            accessLevelsData: [],
            filterByLevel: '',
            showTable: false,
        };
    },
    computed: {
        ...mapGetters('header', ['userCurrencySymbol']),

        accessLevelsDropdown() {
            const list = this.accessLevels.map((item) => {
                return {
                    label: item.name,
                    click: () => {
                        this.filterByLevel = item.id;
                        this.refresh();
                    },
                };
            });
            list.unshift({
                label: 'All',
                click: () => {
                    this.filterByLevel = '';
                    this.refresh();
                },
            });
            return list;
        },

        accessLevelsDropdownLabel() {
            return this.accessLevels.find((item) => item.id === this.filterByLevel)?.name || 'All';
        },

        options() {
            return {
                chart: {
                    type: 'bar',
                    id: 'admin-app-statistics-chart',
                    width: '100%',
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                            this.filterByLevel = this.accessLevels[config.dataPointIndex].id;
                            this.showTable = false;
                            setTimeout(() => {
                                this.refresh();
                            }, 100);
                        },
                    },
                },

                xaxis: {
                    categories: this.accessLevels.map((item) => item.name),
                    labels: {
                        formatter: function (val) {
                            return truncate(val, 18);
                        },
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
            };
        },

        series() {
            return [
                {
                    name: 'Users',
                    data: this.accessLevelsData,
                },
            ];
        },

        columnDefs() {
            return [
                {
                    field: 'modified',
                    headerName: 'Last Day Active',
                    type: 'dateColumn',
                    minWidth: 150,
                },
                {
                    field: 'created',
                    headerName: 'First Login',
                    type: 'dateColumn',
                },
                {
                    field: 'user.id',
                    headerName: 'User ID',
                    minWidth: 120,
                },
                {
                    field: 'user.email',
                    headerName: 'User Email',
                    minWidth: 225,
                },
                {
                    field: 'app_version',
                    headerName: 'App Version',
                    minWidth: 150,
                },
                {
                    field: 'device_os',
                    headerName: 'Device OS',
                    minWidth: 150,
                },
                {
                    field: 'device_model',
                    headerName: 'Device Model',
                    minWidth: 200,
                },
                {
                    field: 'user.access_level',
                    headerName: 'Access Level',
                    autoWidthExclude: true,
                },
            ];
        },
        excelHref() {
            return `${ADMIN_APP_STATISTICS_ENDPOINT()}excel/?offset=${this.offset}&limit=${this.limit}&sort=${
                this.sort
            }&desc=${this.desc}&search=${this.search}&user=${this.selectedUser}&subscriber=${this.selectedSubscriber}`;
        },
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                return API.get(`${ADMIN_APP_STATISTICS_ENDPOINT()}grid/`, {
                    params: {
                        offset,
                        limit,
                        sort,
                        desc,
                        search,
                        access_level: this.filterByLevel,
                        user: this.selectedUser,
                        subscriber: this.selectedSubscriber,
                    },
                });
            };
        },
        goBack() {
            return () => {
                this.showTable = !this.showTable;
                this.filterByLevel = '';
                if (this.showTable) {
                    this.refresh();
                }
            };
        },
    },
    mounted() {
        this.rowStyle = (params) => {
            if (params.node.rowPinned) {
                return { 'font-weight': 'bold' };
            }
        };
        Promise.all([
            this.fetchSubscribers(),
            this.fetchUsers(),
            this.fetchAccessLevels(),
            this.fetchAccessLevelsData(),
        ]);
    },
    methods: {
        onSearchInput: debounce(function () {
            this.refresh();
        }, 500),
        async fetchSubscribers() {
            try {
                this.busy = true;
                const { data } = await API.get(`${ADMIN_APP_STATISTICS_ENDPOINT()}subscribers/`, {
                    params: {
                        search: this.subscriberSearch,
                    },
                });
                this.subscribersList = data.map(({ user }) => ({
                    text: `${user.id} - ${user.email}`,
                    value: user.id,
                }));
            } catch (e) {
                this.errorToast({ text: 'Could not fetch subscribers' });
            } finally {
                this.busy = false;
            }
        },
        async fetchUsers() {
            try {
                this.usersList = [];
                this.busy = true;
                const { data } = await API.get(`${ADMIN_APP_STATISTICS_ENDPOINT()}users/`, {
                    params: {
                        search: this.userSearch,
                    },
                });
                data.forEach((pair) => {
                    const user = {
                        text: `${pair.id} - ${pair.email}`,
                        value: pair.id,
                    };
                    this.usersList.push(user);
                });
            } catch (e) {
                this.errorToast({ text: 'Could not fetch users' });
            } finally {
                this.busy = false;
            }
        },
        selectSubscriber(text, value) {
            this.subscriberSearch = text;
            this.selectedSubscriber = value;
            this.subscribersList = [];
            this.refresh();
        },
        selectUser(text, value) {
            this.userSearch = text;
            this.selectedUser = value;
            this.usersList = [];
            this.refresh();
        },
        searchSubscribers: debounce(function (value) {
            this.subscriberSearch = value;
            this.selectedSubscriber = '';
            if (value === '') {
                this.refresh();
            } else {
                this.fetchSubscribers();
            }
        }, 500),
        searchUsers: debounce(function (value) {
            this.userSearch = value;
            this.selectedUser = '';
            if (value === '') {
                this.refresh();
            } else {
                this.fetchUsers();
            }
        }, 500),
        refresh() {
            this.$refs.grid.refreshDataSource();
        },
        async fetchAccessLevels() {
            try {
                this.accessLevels = [];
                this.busy = true;
                const { data } = await API.get(`${ADMIN_APP_STATISTICS_ENDPOINT()}access-levels/`);
                this.accessLevels = data.groups;
            } catch (e) {
                this.errorToast({ text: 'Could not fetch access levels' });
            } finally {
                this.busy = false;
            }
        },

        async fetchAccessLevelsData() {
            try {
                this.accessLevelsData = [];
                this.busy = true;
                const { data } = await API.get(`${ADMIN_APP_STATISTICS_ENDPOINT()}access-levels-chart-data/`);
                this.accessLevelsData = data.map((item) => {
                    return item.value;
                });
            } catch (e) {
                this.errorToast({ text: 'Could not fetch chart access levels' });
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.subscribers-list-wrapper {
    top: 40px;
}
.subscribers-wrapper {
    min-width: 300px;
}
</style>
